import { render, staticRenderFns } from "./AddDeepLink.vue?vue&type=template&id=64ea7ef3"
import script from "./AddDeepLink.vue?vue&type=script&lang=js"
export * from "./AddDeepLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports